import { Injectable } from '@angular/core';
import { ActivationEnd, Params } from '@angular/router';

import { RouteTag } from '@frontend/sports/common/core/data-access/route';
import { SessionStoreService, toBoolean } from '@frontend/vanilla/core';
import { clone, findIndex, isEqual } from 'lodash-es';

export interface RouteHistoryData {
    tag: RouteTag;
    params: Params;
}

@Injectable()
export class LiveHistoryService {
    private static storageKey = 'live-history';

    constructor(private store: SessionStoreService) {}

    getHistory(): RouteHistoryData[] {
        return this.store.get(LiveHistoryService.storageKey) || [];
    }

    saveRouteData(data: ActivationEnd): void {
        if (!this.canBePersisted(data)) {
            return;
        }

        const tag = data.snapshot.data.tag;
        const params = clone(data.snapshot.params);

        if (toBoolean(data.snapshot.queryParams.fallback) === false) {
            params.region = -1;
        }

        const history = this.getHistory();
        const matchingIndex = this.findRouteIndex(history, tag, params);

        if (matchingIndex > -1) {
            history.splice(matchingIndex, 1);
        }

        history.push({ tag, params });

        this.store.set(LiveHistoryService.storageKey, history);
    }

    private findRouteIndex(history: RouteHistoryData[], tag: RouteTag, params: Params): number {
        return findIndex(history, (h) => h.tag === tag && isEqual(h.params, params));
    }

    private canBePersisted(data: ActivationEnd): boolean {
        return data && data.snapshot && data.snapshot.data && data.snapshot.data.persist;
    }
}
